/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Button, Icon, message, Table, Popconfirm, Empty } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			isBackuping: false
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// reservation_status: filters.status,
		})
	}

	render() {
		const { AuthStore } = this.props
		const { barangay_uid } = AuthStore
		const { 
			page, pageSize, sortOrder, sortName, searchText, isBackuping
		} = this.state
		const filters = { 
			page, pageSize, searchText, sortOrder, sortName
		}
		
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item"><Link to='/'>Dashboard</Link></li>
									<li className="breadcrumb-item"><a href='javascript:void(0)'>Utilities</a></li>
									<li className="breadcrumb-item active">Database Backup</li>
								</ol>
							</div>
							<h4 className="page-title">Database Backup</h4>
						</div>
					</div>
				</div>
				<div className="row" style={{ minHeight: '600px' }}>
					<div className="col-12">
						<div className='card'>
							<div className='card-body'>
								<Row type='flex' justify='center'>
									<Col md={24} sm={24}>
										<Row>
											<button disabled={isBackuping} type="button" className="btn btn-primary btn-rounded waves-effect waves-light" onClick={() => {
												const { manualBackup } = this.props
												const params = { barangay_uid }
												this.setState({ isBackuping: true }, () => {
													manualBackup(params)
														.then(() => {
															this.setState({ isBackuping: false })
															message.success('Database successfully backup')
														})
														.catch(err => {
															this.setState({ isBackuping: false })
															message.error('Error backup database', err.message)
														})
												})
											}} style={{ float: 'right' }}>Manual Backup</button>
											<Input placeholder='Search Here' style={{ width: 230, float: 'right', marginRight: 20, marginTop: 5 }} onChange={(e) => {
												this.setState({ searchText: e.target.value })
											}}/>
										</Row>
										<br />
										<Row>
											<Query 
												query={DATABASE_BACKUP} 
												variables={{ searchFilter: filters, barangay_uid }}
												fetchPolicy='network-only'
											>
												{({ loading, error, data }) => {
													if (error) return <Empty/>

													let barangayDatabaseBackup = _.has(data,'barangayDatabaseBackup') ? data.barangayDatabaseBackup.data : []
													barangayDatabaseBackup = barangayDatabaseBackup.map((backup, key) => Object.assign({}, backup, { key }))
													let _pagination = _.has(data, 'barangayDatabaseBackup') ? data.barangayDatabaseBackup.pagination : {}
													_pagination = Object.assign({}, _pagination, {
														pageSizeOptions: ['10', '25', '50'],
														showSizeChanger: true,
														total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
														showTotal: (total) => `Total ${total} items`
													})

													const columns = [{
														title: 'Backup Date',
														key: 'backup_date',
														render: (record) => {
															return <span>{moment(record.backup_date).format('lll')}</span>
														}
													}, {
														title: 'Filename',
														key: 'file_name',
														render: (record) => {
															return (
																<a
																	href={`${process.env.REACT_APP_BACKEND_API}${record.file_url}`}
																	target='_blank'
																	download
																>{record.file_name}</a>
															)
														}
													}, {
														title: 'Error log',
														dataIndex: 'error_logs',
														key: 'error_logs'
													}]
													return (
														<Table 
															loading={loading}
															columns={columns} 
															dataSource={barangayDatabaseBackup} 
															bordered
															onChange={this.handleOnChange}
															pagination={_pagination}
															scroll={{ x: 1020 }}
														/>
													)
												}}
											</Query>
										</Row>
									</Col>
								</Row>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

const DATABASE_BACKUP = gql`
    query barangayDatabaseBackup($barangay_uid: String, $searchFilter: SearchParams) {
		barangayDatabaseBackup(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const MANUAL_BACKUP = gql`
    mutation setManualDatabaseBackup($input: JSON) {
		setManualDatabaseBackup(input: $input)
    }
`

const composed = compose(
	inject('AuthStore'),
	graphql(MANUAL_BACKUP, {
		props({ mutate }) {
			return {
				manualBackup(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangayDatabaseBackup']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
